import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

import { transformResponseMerchantRefundMethods, transformResponsePortalRefundMethods } from './transformers'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getPreferences: configurationServices.getMerchantPreferences,
    getRefundMethods: configurationServices.getMerchantRefundMethods,
    transformResponseRefundMethods: transformResponseMerchantRefundMethods,
    saveConfiguration: configurationServices.editMerchantRefundMethodsConfiguration,
  },
  [configurationTypes.returnsPortal]: {
    getPreferences: configurationServices.getPortalPreferences,
    getRefundMethods: configurationServices.getPortalRefundMethods,
    transformResponseRefundMethods: transformResponsePortalRefundMethods,
    saveConfiguration: configurationServices.editPortalRefundMethodsConfiguration,
  },
}
